import { TRANSLATIONS } from 'translations/index';

import {
  isRequired,
  isRequiredCurrency,
  
} from 'utils/validators';

const validate = (values, props) => {
  const errors = {};

  const { languages } = props;
  const secondLanguage = languages[languages.length - 1];

  if (values.mandatoryFees && values.mandatoryFees.length) {
    const mandatoryFees = values.mandatoryFees;
    const mandatoryFeesArrayErrors = [];

    mandatoryFees.forEach((item, itemIndex) => {
      let mandatoryFeesErrors = {};

      if (languages.length > 1) {
        if (
          !item[secondLanguage] ||
          isRequired(item[secondLanguage].title || '', true)
        ) {
            mandatoryFeesErrors = {
            [secondLanguage]: {
              title: TRANSLATIONS[secondLanguage].titleIsRequired
            }
          };
          mandatoryFeesArrayErrors[itemIndex] = mandatoryFeesErrors;
        }
      }

     

      if (isRequired(item.title || '', true)) {
        mandatoryFeesErrors.title = 'Title is required';
        mandatoryFeesErrors[itemIndex] = mandatoryFeesErrors;
      }

      if (isRequiredCurrency(item)) {
        mandatoryFeesErrors['USD'] = 'Error';
        mandatoryFeesErrors['EUR'] = 'Error';
        mandatoryFeesErrors['NOK'] = 'Error';
        mandatoryFeesArrayErrors['_error'] = {
          ...mandatoryFeesArrayErrors['_error'],
          [itemIndex]:
            'Value for at least one currency for each category should be filled in'
        };
        mandatoryFeesArrayErrors[itemIndex] = mandatoryFeesErrors;
      }
    });

    if (mandatoryFeesArrayErrors.length) {
      errors.mandatoryFees = mandatoryFeesArrayErrors;
      errors.mandatoryFees   = {
        ...mandatoryFeesArrayErrors,
        _error: { ...mandatoryFeesArrayErrors }
      };
    }
  }

  return errors;
};

export default validate;
